import { useSetAtom } from 'jotai';
import { useCallback } from 'react';

import {
  drawerIsOpenAtom,
  drawerTypeAtom,
} from '@/features/equipment-browser/equipment-drawer-loader/state/drawer.state';

import { deviceIdsAtom, deviceKindAtom, pushOutModeAtom } from '../state/bulk-edit-params.state';

export const useOpenBulkEdit = () => {
  const setDeviceKind = useSetAtom(deviceKindAtom);
  const setDeviceIds = useSetAtom(deviceIdsAtom);
  const setDrawerIsOpen = useSetAtom(drawerIsOpenAtom);
  const setDrawerType = useSetAtom(drawerTypeAtom);
  const setPushOutMode = useSetAtom(pushOutModeAtom);

  const openBulkEditAction = (deviceKind: string, deviceIds: string[]) => {
    setDeviceKind(deviceKind);
    setDeviceIds(deviceIds);
    setDrawerType('bulk-edit');
    setDrawerIsOpen(true);
  };

  const clearBulkEditAction = useCallback(() => {
    setDeviceKind(undefined);
    setDeviceIds(undefined);
    setDrawerIsOpen(false);
    setDrawerType(undefined);
    setPushOutMode(null);
  }, [setDeviceIds, setDeviceKind, setDrawerIsOpen, setDrawerType, setPushOutMode]);

  return {
    openBulkEditAction,
    clearBulkEditAction,
  };
};
